module.exports = __webpack_public_path__ + "static/media/ios-arrow-dropright.60819826.svg";